/**
 * Header Mobile Submenus
 *
 * Handles toggling the header submenus on small screens
 */

( function( $ ) {
	$( '.sub-menu-toggle' ).click( function( e ) {
		if ( $( this ).parent().hasClass( 'menu-item-has-children' ) ) {
			$( this ).next().toggleClass( 'toggle' );
			$( this ).parent().toggleClass( 'toggled' );
		}
	} );
}( jQuery ) );
